import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom"; // 📌 Düzenleme modunda ID almak için
import "./YoneticiGruplari.css";
import { FiSave } from "react-icons/fi";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PageHeader from '../../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../../components/leadsViewCreate/LeadsCreateHeader'

const BLANK_PERMS = {
  full_access: false,
  view_permission: false,
  create_permission: false,
  edit_permission: false,
  status_permission: false,
  delete_permission: false,
  trash_permission: false,
  sort_permission: false,
};

/* Statik modül listesi */
const STATIC_MODULES = [
  { id: null, name: "Kullanıcılar",          key: "static_users" },
  { id: null, name: "Yönetici Hesapları",    key: "static_admin_accounts" },
  { id: null, name: "Url yönlendirme",       key: "static_url_redirect" },
  { id: null, name: "Mail Şablonları",       key: "static_mail_template" },
  { id: null, name: "Geliştirici Ayarları",  key: "static_developer_settings" },
  { id: null, name: "Roller",                key: "static_roles" },
  { id: null, name: "Tanımlar",              key: "static_definitions" },
  { id: null, name: "Modüller",              key: "static_modules" },
  { id: null, name: "Navigate Menü",         key: "static_navigate" },
  { id: null, name: "Versiyon",              key: "static_version" },
  { id: null, name: "Yardım Merkezi",        key: "static_help_center" },
];


const YoneticiGruplari = () => {
  const { id } = useParams(); // Edit modunda gelen rol ID'si
  const [selectedRole, setSelectedRole] = useState(""); 
  const [modules, setModules] = useState([]); 
  const [loading, setLoading] = useState(false); 
  const [saving, setSaving] = useState(false);
  const [rolesOptions, setRolesOptions] = useState([]);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    if (id) {
      fetchRoleAndModules(id); 
    }
  }, [id]);

  const fetchRoles = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/roles`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Roller API Yanıtı:", resp.data);

      const formattedRoles = resp.data.map((role) => ({
        label: role.role_name,
        value: role.id, 
      }));

      setRolesOptions(formattedRoles);

      // Edit modunda, ilgili rolü otomatik seç
      if (id) {
        const foundRole = formattedRoles.find((role) => role.value === Number(id));
        if (foundRole) {
          setSelectedRole(foundRole.value);
        }
      }
    } catch (error) {
      console.error("❌ Roller alınamadı:", error);
    }
  };

  const fetchRoleAndModules = async (roleId) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("admin_token");

      //Seçili rolün bilgilerini getir
      const roleResp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/roles/${roleId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Seçili Rol API Yanıtı:", roleResp.data);
      setSelectedRole(roleResp.data.id);

      // Modülleri ve yetkileri getir
      const moduleResp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/modules`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("API'den Gelen Modüller:", moduleResp.data);
      

      let normalizedModules = [
          /* dinamik modüller */
           ...moduleResp.data.map((modul) => ({
             ...modul,
             key: null,            // dinamiklerde key yok
             ...BLANK_PERMS,
           })),
           /* statik modüller — EKLENDİ */
           ...STATIC_MODULES.map((m) => ({ ...m, ...BLANK_PERMS })),
         ];

      const permResp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/permissions/${roleId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log(`Role ${roleId} Yetkileri API Yanıtı:`, permResp.data);
      const rolePermissions = permResp.data;

      // Yetkileri modüllere uygula
      normalizedModules = normalizedModules.map((modul) => {
        const rolePermission = rolePermissions.find(
             (p) =>
               (modul.id && Number(p.module_id) === Number(modul.id)) ||   // dinamik
               (!modul.id && p.module_key === modul.key)                  // statik
           );
        return rolePermission
          ? {
              ...modul,
              full_access: Boolean(rolePermission.full_access),
              view_permission: Boolean(rolePermission.view_permission),
              create_permission: Boolean(rolePermission.create_permission),
              edit_permission: Boolean(rolePermission.edit_permission),
              status_permission: Boolean(rolePermission.status_permission),
              delete_permission: Boolean(rolePermission.delete_permission),
              trash_permission: Boolean(rolePermission.trash_permission),
              sort_permission: Boolean(rolePermission.sort_permission),
            }
          : modul;
      });

      console.log("Güncellenmiş Modüller:", normalizedModules);
      setModules(normalizedModules);
    } catch (error) {
      console.error("Modüller alınamadı:", error);
      setModules([]);
    }
    setLoading(false);
  };

  const handleToggleChange = (moduleIndex, field) => {
    setModules((prevModules) => {
      const updatedModules = [...prevModules];
      const module = { ...updatedModules[moduleIndex] };

      module[field] = !module[field];

      if (field === "full_access") {
        const newValue = module.full_access;
        module.view_permission = newValue;
        module.create_permission = newValue;
        module.edit_permission = newValue;
        module.status_permission = newValue;
        module.delete_permission = newValue;
        module.trash_permission = newValue;
        module.sort_permission = newValue;
      }

      updatedModules[moduleIndex] = module;
      return updatedModules;
    });
  };

  const handleSavePermissions = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem("admin_token");

      const payload = {
        role: selectedRole,
        permissions: modules.map((modul) => ({
          module_id: modul.id,
          module_key: modul.key || null,
          full_access: modul.full_access,
          view_permission: modul.view_permission,
          create_permission: modul.create_permission,
          edit_permission: modul.edit_permission,
          status_permission: modul.status_permission,
          delete_permission: modul.delete_permission,
          trash_permission: modul.trash_permission,
          sort_permission: modul.sort_permission,
        })),
      };

      console.log("📤 Gönderilen Payload:", JSON.stringify(payload, null, 2));

      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/permissions/update`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Yetkiler başarıyla güncellendi!", {
        position: "top-right",
        autoClose: 3000,
      });
  
    } catch (error) {
      console.error("Yetkiler kaydedilirken hata:", error.response?.data || error);
      alert("Yetkiler güncellenirken hata oluştu!");
    }
    setSaving(false);
  };


  return (
    <div className="page-content p-4">
     <ToastContainer />

      {/*  PANEL */}
      <div className="card stretch stretch-full function-table">
        <div className="card-body p-0">
          <div className="panel-body p-4">
          <div className="mb-3">
          <label className="form-label fw-bold">{getText("ROLES_SELECT_LABEL")}</label>
          <select className="form-select disabled-select" value={selectedRole} disabled>
            <option value="">
              {rolesOptions.find((role) => role.value === selectedRole)?.label || "Rol Seç"}
            </option>
          </select>
        </div>


          {loading && <p className="text-center p-3">{getText("MODULE_LOADING")}</p>}

          {!loading && modules.length > 0 && (
            <div className="table-responsive">
             <div className="dataTables_wrapper dt-bootstrap5 no-footer">
              <div className="row dt-row">
                <div className="col-sm-12 px-0">
                  <table className="table table-hover dataTable no-footer">
                  <thead>
                      <tr>
                        <th style={{ width: "30%" }}>{getText("MODULE_NAME")}</th> {/* Genişletilmiş alan */}
                        <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_FULL")}</th>
                        <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_LIST")}</th>
                        <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_PREVIEW")}</th>
                        <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_ADD")}</th>
                        <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_EDIT")}</th>
                        <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_STATUS")}</th>
                        <th className="text-start" style={{ width: "10%" }}>{getText("PERMISSION_DELETE")}</th>
                        <th className="text-start" style={{ width: "10%" }}>{getText("PERMISSION_TRASH")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modules.map((modul, index) => (
                        <tr key={modul.id || `modul-${index}`}>
                          <td style={{ width: "30%" }}>{modul.name}</td>
                          
                          {["full_access", "sort_permission", "view_permission", "create_permission", "edit_permission", "status_permission", "delete_permission", "trash_permission"].map((permKey) => (
                            <td key={`${modul.id}-${permKey}`} className="text-center" style={{ width: "10%" }}>
                              <label className="switch">
                                <input type="checkbox" checked={modul[permKey]} onChange={() => handleToggleChange(index, permKey)} />
                                <span className="slider round"></span>
                              </label>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>

              </table>
              </div>
              </div>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-center mt-3">
            <button className="btn btn-primary d-flex align-items-center shadow-sm" onClick={handleSavePermissions} disabled={saving}>
              <FiSave className="me-2" />
              {getText("SAVE_BTN")}
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};
export default YoneticiGruplari;
